export default "__VITE_ASSET__Cymio9Ko__"